import React, { Component } from "react";
//import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { LOGIN_TYPE_ADMIN,LOGIN_TYPE_USER, ClientsAnalysis, Dashboard_API_Hit_Report, Dashboard_Mobile_App, Dashboard_Api_hit_counts, Months, SERVICE42_TEXT } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
//import Parser from 'html-react-parser';
//import { Link } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import Select2 from 'react-select2-wrapper';
import $ from "jquery";
import 'react-select2-wrapper/css/select2.css';
//import 'react-select2-wrapper/css/select2.css';
//import { Alert } from 'rsuite';
import { Chart } from "react-google-charts";

import Header from "./include/Header";



class DashboardClient extends Component {
  constructor(props) {
    let year = new Date().getFullYear();
    let crMonth = new Date().getMonth() + 1;
    super(props);
    this.state = {
      //filter graph
      clientist: [{ text: 'All Client', id: -1, value: 'all client' }],
      lastSixMont: [],
      currentMonth: '',
      selectedClient: '',

      //using API Hits Reports
      totalHits:'--',
      hitsData:[],
      planList:[],
      //api hit
      selectUser: 'all client',
      selectApitype: 'all',
      apiHitReportLoading: false,
      APIHitsStartDate: '',
      APIHitsEndDate: '',
      backDate: '',
      apiHitReportShow: false,
      
      //doc info
      selectPersonalApitype: 'all',
      docInfoSelectClient: 'all client',
      docInfoStartDate: '',
      docInfoEndDate: '',
      docInfoSecShow: false,
      docInfoData: {},
      appInfoSecShow: false,

      //graphs data
      graphFilters:{year:year, type:'daily', month:crMonth, monthQut:'1_3', clientType:'', graphData:[]}
    }
  }

  componentDidMount() {
    let date_ob = new Date();
    let date = ("0" + (date_ob.getDate())).slice(-2);
    let month1 = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    var startDate = year + "-" + month1 + "-01";
    var enddate = year + "-" + month1 + "-" + date;
    date_ob.setDate(date_ob.getDate() - 31);
    this.setState({
      APIHitsStartDate: startDate,
      APIHitsEndDate: enddate,
      backDate: '2023-11-01', //date_ob.toISOString().slice(0, 10)
      docInfoStartDate: startDate,//date_ob.toISOString().slice(0, 10),
      docInfoEndDate: enddate,
      graphFilters: {...this.state.graphFilters, 'clientType':reactLocalStorage.get("login_user_id")},
      selectUser: reactLocalStorage.get("login_user_id"),
      docInfoSelectClient: reactLocalStorage.get("login_user_id")
    });

    this.getClientPlans();
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_USER) {
      setTimeout(()=>{
        this.filterGraph();
      },100)
    }
  }
  filterHitReport = () => {
    var startDate = this.state.APIHitsStartDate;
    var endDate = this.state.APIHitsEndDate;
    let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    this.state.apiHitReportLoading = true;
    
    //var selectMonth = $("#selectMonth").val();
    var apitype = $("#selectApi").val();
    if (apitype === null || apitype === '' || apitype === 'all') {
      apitype = 'all';
    }
   
    if (dayDiff <= 31) {
      this.filterAPIHitReport(startDate, endDate, apitype);
    } else {
      alert('Please select date range maximum 31 days');
    }
  }

  filterAPIHitReport(startDate, endDate, apitype) {
    $(".loader").show();
    let inputData = { 
      'selectedClient': this.state.selectUser, 
      'startDate': startDate, 
      'endDate': endDate, 
      'apitype': apitype 
    };
    if (apitype === 'all') {
      let plans = [];
      this.state.planList.forEach((it)=>{
        plans.push(it.serSeq);
      });
      inputData.apitype = plans;
    }
    //console.log('inputData', inputData);
    //return;
    Apihelpers.postdataresponse('Dashboard/api-hit-reports-for-client-dashboard', inputData).then(res => {
      if (res.data.status === true) {
        console.log('res.data.data', res.data.data);
        let resData = res.data.data;
        this.setState({
          totalHits:resData.totalHits,
          hitsData: resData.data
        });
      } else {
        console.log('res.data', res.data);
        this.setState({
          totalHits:'--',
          hitsData: []
        });
      }
      $(".loader").hide();
      this.state.apiHitReportLoading = false;
    });
  }

  apiHitInfoSecOpen = () => {
    if(this.state.apiHitReportShow) {
      this.setState({apiHitReportShow:false})
    } else {
      this.setState({apiHitReportShow:true});
      this.filterHitReport()
    }
  }

  filterDocumentInfo = () => {
    let startDate = this.state.docInfoStartDate;
    let endDate = this.state.docInfoEndDate;
    let selectClient = this.state.docInfoSelectClient;
    let api_type = this.state.selectPersonalApitype;
    if (selectClient == null || selectClient == 'all client') {
      selectClient = '-1';
    }
    $(".loader").show();
    let inputData = { 'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, "apitype": api_type };
    Apihelpers.postdataresponse('Dashboard/reports-for-personalnfoapihit', inputData).then(res => {
      if (res.data.status === true) {
        //console.log('res.data.data',res.data.data);
        this.setState({ docInfoData: res.data.data });
        $(".loader").hide();
      } else {
        console.log('res.data', res.data);
        this.setState({ docInfoData: {} });
      }
    })
  }
  showDocInfoSec = () => {
    if (this.state.docInfoSecShow) {
      this.setState({
        docInfoSecShow: false
      });
    } else {
      this.filterDocumentInfo();
      this.setState({
        docInfoSecShow: true
      });
    }
  }
  printVal = (val) => {
    return (val === undefined || val === "") ? '--' : val;
  }
  
  filterGraph = () => {
    let parms = '?year='+this.state.graphFilters.year+'&type='+this.state.graphFilters.type+'&clientType='+this.state.graphFilters.clientType+'&month='+this.state.graphFilters.month+'&monthQut='+this.state.graphFilters.monthQut;
    $(".loader").show();
    Apihelpers.getdataresponse(Dashboard_Api_hit_counts+parms).then((res)=>{
      if(res.data.status === true) {
        let data = res.data.data;
        console.log('data',data);
        let dataArray = [];
        if (this.state.graphFilters.type === 'monthly') {
          let monthQut = this.state.graphFilters.monthQut.split('_');
          if (this.state.graphFilters.clientType !== 'topTen') {
            dataArray = [['Month', 'Counts']];
            Months.forEach((m,i)=>{
              if ((i+2) > monthQut[0] && i < monthQut[1]) {
                let array = data.filter((obj)=> (obj._id == (i+1)) );
                if(array.length > 0) {
                  dataArray.push([m, array[0].count]);
                } else {
                  dataArray.push([m, 0]);
                }
              }
            });
          }
        } else if (this.state.graphFilters.type === 'daily') {
          if (this.state.graphFilters.clientType !== 'topTen') {
            dataArray = [['Daily', 'Counts']];
            data.forEach((aa)=>{
              let crmm = new Date().getMonth()+1;
              if(aa[0] > new Date().getDate() && aa[1] === 0 && crmm == this.state.graphFilters.month ) {
                //console.log('data is next days with 0 value',aa);
              } else {
                let newAa = aa;
                newAa[0] = newAa[0].toString();
                dataArray.push(newAa);
              }
            });
          }
          
        }
        console.log('dataArray',dataArray);
        this.setState({
          graphFilters: {...this.state.graphFilters, 'graphData': dataArray}
        })
        $(".loader").hide();
      }
    })
  }

  getClientPlans = () => {
    let clientId = reactLocalStorage.get("login_user_id");
    $(".loader").show();
    Apihelpers.getdataresponse('Dashboard/get-client-assign-plans?clientId='+clientId).then(res => {
      if (res.data.status === true) {
        console.log('res.data.data', res.data.data);
        this.setState({
          planList:res.data.data,
        });
      } else {
        console.log('res.data', res.data);
        this.setState({
          planList:[],
        });
      }
      $(".loader").hide();
    });
  }

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_USER) {
      let crYear = new Date().getFullYear();
      return (
        <React.Fragment>
          <div className="wrapper dashboardPage dashboardClient">
            <Header />
            <div className="container">
              <div className="infoTabe clientInfoSec">
                <div className="clientInfoNew">
                  <h4 className="title"> API Uses & analyses </h4>
                </div>
                
                <div className="graphBlock">
                  {
                    //JSON.stringify(this.state.planList, null,2)
                  }
                    {
                      //JSON.stringify(this.state.graphFilters,null,2)
                    }
                  <div className="blockFilter form">
                    <div className="row">
                      <div className="col"></div>
                      <div className="col-md-2">
                        <select className="form-control" onChange={
                          (e) => {
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'type':e.target.value}
                            })
                          } 
                        } defaultValue={this.state.graphFilters.type}>
                          <option value="monthly">Monthly</option>
                          {/* <option value="weekly">Weekly</option> */}
                          <option value="daily">Daily</option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <select className="form-control" onChange={
                          (e) => {
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'year':e.target.value}
                            })
                          }
                        } defaultValue={this.state.graphFilters.year}>
                          <option value={crYear}>{crYear}</option>
                          <option value={crYear-1}>{crYear-1}</option>
                          <option value={crYear-2}>{crYear-2}</option>
                          <option value={crYear-3}>{crYear-3}</option>
                        </select>
                      </div>
                      {
                        (this.state.graphFilters.type === 'daily') ?
                        <div className="col-md-2">
                          <select className="form-control" onChange={
                            (e) => {
                              this.setState({
                                graphFilters: {...this.state.graphFilters, 'month':e.target.value}
                              })
                            }
                          } value={this.state.graphFilters.month}>
                            {
                              Months.map((it,i)=>{
                                return (<option key={i} value={i+1}>{it}</option>)
                              })
                            }
                          </select>
                        </div>
                      :
                        <div className="col-md-2">
                          <select className="form-control" onChange={(e)=>{
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'monthQut':e.target.value}
                            })
                          }} 
                          value={this.state.graphFilters.monthQut}>
                            <option value="1_3">January to March</option>
                            <option value="4_6">April to June</option>
                            <option value="7_9">July to September</option>
                            <option value="10_12">October to December</option>
                          </select>
                        </div>
                      }
                      {/* <div className="col-md-2">
                        <Select2
                          data={[{ "text": "Every Client", "value": "topTen" }, ...this.state.clientist]}
                          options={{
                            placeholder: 'select client',
                          }}
                          className="form-control"
                          value={this.state.graphFilters.clientType}
                          onChange={(e) => {
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'clientType':e.target.value}
                            })
                          }}
                        />
                      </div> */}
                      <div className="col-md-auto">
                        <button className="blueBtn" type="button" onClick={this.filterGraph}>Filter</button>
                      </div>
                      <div className="col"></div>
                    </div>
                  </div>
                  {
                    this.state.graphFilters.graphData.length > 0 ?
                    <Chart
                    chartType="LineChart"
                    width="100%"
                    height="400px"
                    data={this.state.graphFilters.graphData}
                    options={{
                      //title: 'Company Performance',
                      //curveType: 'function',
                      //hAxis: { title: "Date" },
                      vAxis: { title: "API Hit Counts"},
                      legend: { position: 'top' },
                      lineWidth: 3,
                      'chartArea': { left: 100, top: 70, 'width': '90%', 'height': '70%' },
                    }}
                  />
                  :
                  <div style={{'textAlign':'center', 'padding':'15px', 'color':'gray'}}>Data is not available</div>
                  }
                  
                </div>
              </div>

              <div className="infoTabe apiHitInfo">
                <h4 className="headBg">
                  API Hits Reports <span className="arrow" onClick={this.apiHitInfoSecOpen}><i className="fa fa-chevron-circle-down"></i></span>
                </h4>
                {
                  //JSON.stringify(this.state.hitsData, null,2)
                }
                <div style={this.state.apiHitReportShow ? {} : {'display':'none'}}>
                  <div className="blockFilter form">
                    <div className="row">
                      {/* <div className="col-md">
                        <div className="form-group">
                          <label className="control-title">Select Plan Type</label>
                          <select id="selectApi" className="form-control" onChange={(e) => this.setState({ selectApitype: e.target.value })}>
                            <option value="all">All</option>
                            <option value="9">RCPrime</option>
                            <option value="10">RCExcel</option>
                            <option value="2">Challan</option>
                            <option value="36">ChallanExcel</option>
                            <option value="15">RCPrimeReverse</option>
                            <option value="3">Service History</option>
                            <option value="14">Used Car Pricing</option>
                            <option value="0">Free RC</option>
                            <option value="16">RCPrimeReverseBasic</option>
                            <option value="19">Used Car Pricing v2</option>
                            <option value="32">comboPrime</option>
                            <option value="33">comboChallan</option>
                            <option value="37">Mobile Vehicle</option>
                            <option value="38">comboMobileVehicle</option>
                          </select>
                        </div>
                      </div> */}
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Select Start Range</label>
                          <input className="form-control" min={this.state.backDate} id="startDate" value={this.state.APIHitsStartDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ APIHitsStartDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-title">Select End Range</label>
                          <input className="form-control" min={this.state.backDate} id="endDate" value={this.state.APIHitsEndDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ APIHitsEndDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-auto">
                        <button onClick={this.filterHitReport} className="blueBtn">Filter</button>
                      </div>
                    </div>
                  </div>
                  <div className="dasInfoTable">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Plan Type</th>
                          <th>Success</th>
                          <th>Failure</th>
                          <th>Time Out</th>
                          <th>Incomplete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          (this.state.hitsData.length> 0) ?
                            this.state.hitsData.map((trItem)=>{
                              return(
                                <tr>
                                  <td>{trItem?.plan_type}</td>
                                  <td>{trItem?.success}</td>
                                  <td>{trItem?.failure}</td>
                                  <td>{trItem?.timeout}</td>
                                  <td>{trItem?.incomplete}</td>
                                </tr>
                              )
                            })
                          :
                          <tr>
                            <td colSpan={5}>Data is not available</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="infoTabe docInfoSec" style={{display: 'none'}}>
                <h4 className="headBg">
                  <span>Document Verification API Hits Report</span>
                  <span className="arrow" onClick={this.showDocInfoSec}><i className="fa fa-chevron-circle-down"></i></span>
                </h4>
                <div className="blockFilter form" style={this.state.docInfoSecShow ? {} : { display: 'none' }}>
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select Plan Type</label>
                        <select id="selectApi" className="form-control" onChange={(e) => this.setState({ selectPersonalApitype: e.target.value })}>
                          <option value="all">All</option>
                          <option value="21">Pan Fetch</option>
                          <option value="26">Pan Extensive</option>
                          <option value="34">Aadhaar Fetch</option>
                          <option value="24">Aadhaar Extraction</option>
                          <option value="22">Basic Forgery</option>
                          <option value="23">Advance Forgery</option>
                        </select>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select Start Range</label>
                        <input className="form-control" min={this.state.backDate} value={this.state.docInfoStartDate} placeholder="Start Date" type="date"
                          onChange={(e) => this.setState({ docInfoStartDate: e.target.value })} />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select End Range</label>
                        <input className="form-control" min={this.state.backDate} value={this.state.docInfoEndDate} placeholder="Start Date" type="date"
                          onChange={(e) => this.setState({ docInfoEndDate: e.target.value })} />
                      </div>
                    </div>
                    <div className="col-auto">
                      <button className="blueBtn" onClick={this.filterDocumentInfo}>Filter Now</button>
                    </div>
                  </div>
                  <div className="dasInfoTable">
                    <div className="table-responsive">
                      <table className="table">
                        
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              
             
            </div>
          </div>
          <div className="loader" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default DashboardClient;
